<p>user-register works!</p>
